import { useSyncExternalStore } from "react";

import { useTheme } from "@mui/material";
import { useAlertBannerHeight } from "@src/providers/layout/useAlertBanner";

const subscribeToScroll = (callback: () => void) => {
  window.addEventListener("scroll", callback, { passive: true });
  return () => window.removeEventListener("scroll", callback);
};

const getServerSnapshot = () => false;

const BILLING_ALERT_INSET_SPACING_UNITS = 2;

export const useBillingAlertInset = () => {
  const bannerHeightPx = useAlertBannerHeight();
  const hasScrolledPastBanner = useSyncExternalStore(
    subscribeToScroll,
    () => window.scrollY >= bannerHeightPx,
    getServerSnapshot
  );

  const theme = useTheme();
  const inset = theme.spacing(BILLING_ALERT_INSET_SPACING_UNITS);
  const isBannerVisible = bannerHeightPx > 0 && !hasScrolledPastBanner;
  const bottomInset = `calc(${inset} + ${isBannerVisible ? bannerHeightPx : 0}px)`;

  return { inset, bottomInset };
};
